import React from 'react';
import { FunctionComponent, useState } from 'react';
import config from '@config';
import SmoothImage, { LazyLoadBreakpoint } from './SmoothImage';

interface ImageIconProps
{
    src: string;
    hoverSrc?: string;
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
    enableLazyLoading?: boolean;
    lazyLoadPixelTreshold?: number;
    lazyLoadBreakpoints?: LazyLoadBreakpoint[];
    className?: string;
    alt?: string,
    onClick?: () => void;
}

const ImageIcon: FunctionComponent<ImageIconProps> = (props) =>
{
    const [isHover, setIsHover] = useState<boolean>(false);
    
    /** Handle the hover effect */
    const onMouseEnter = () => 
    {
        setIsHover(true);
    }

    const onMouseLeave = () =>
    {
        setIsHover(false);
    }
    
    /** Render */
    return (
        <SmoothImage 
            src={config.defaultPublicDirBaseUrl + (isHover && props.hoverSrc ? props.hoverSrc : props.src)}
            width={32}
            height={32}
            enableLazyLoading={props.enableLazyLoading}
            lazyLoadPixelTreshold={props.lazyLoadPixelTreshold}
            lazyLoadBreakpoints={props.lazyLoadBreakpoints}
            className={`image-icon icon-${props.size} ${props.className}`}
            alt={props.alt ?? ''}
            onClick={props.onClick}
            onMouseEnter={() => onMouseEnter()}
            onMouseLeave={() => onMouseLeave()}
        />
    );
}

ImageIcon.defaultProps = {
    size: 2,
    enableLazyLoading: false
}

export default ImageIcon;